// Base components necessary for any file
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './App.css'

// Our custom components
import CharacterDropIn from './components/CharacterDropIn'
import MessageList from './components/MessageList'
import BottomNav from './components/BottomNav'
import EventListener from './components/EventListener'
import WebSocket from './components/WebSocket'
import { addMessage } from './actions/actions'

// Componente from external libraries / dependencies
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import ReactEventSource from 'react-eventsource'

// Router components because were a real website...maybe
import { HashRouter, BrowserRouter, Route, Link, Switch } from 'react-router-dom'

// Container components that are actual page locations to visit and render
import Home from './containers/Home'
import TestBed from './containers/TestBed'
import Graphistry from './containers/Graphistry'
import GraphistryWLAN from './containers/GraphistryWLAN'
import GraphistryMario from './containers/GraphistryMario'
import NoMatch from './containers/NoMatch'

class App extends Component {
    constructor(props) {
        super(props)
        this.source = new EventSource('https://stream.wikimedia.org/v2/stream/recentchange')
        this.source.addEventListener("message", function(e) {
            let user = JSON.parse(e.data).user
        })
    }

    onClickReset = () => {
        this.setState({ viewport: this.DEFAULT_VIEWPORT})
    }

    onViewportChanged = viewport => {
        this.setState({ viewport })
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true
    }

    render() {
        return (
            <HashRouter> 
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/testbed" component={TestBed} />
                    <Route path="/graphistry" component={Graphistry} />
                    <Route path="/graphistry_wlan" component={GraphistryWLAN} />
                    <Route path="/graphistry_mario" component={GraphistryMario} />
                    <Route component={NoMatch} />
                </Switch>
            </HashRouter>
        )
    }
}

const mapStateToProps = state => {
    return {
        state: state
    }
}

export default connect(mapStateToProps)(App)
//export default App



// WEBPACK FOOTER //
// ./src/App.js